module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg2-1.jpg"
    }
  })])]), _c('a', {
    attrs: {
      "id": "page_i"
    }
  }), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "id": "page_i"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("Sachiyo Ishii")]), _vm._v(" was born and raised in Japan. She was a money broker on Wall Street and in London before discovering the joy of handicraft after her second son was born. She learned dressmaking and Waldorf doll making and has been designing and creating dolls and toys ever since. She teaches knitting, doll making, wet and dry felting, sewing, crochet and spinning, among other crafts. She has authored a number of titles for Search Press and her work regularly appears in knitting magazines. Sachiyo lives in Sussex with her husband and two sons. Visit her website at ")]), _c('a', {
    attrs: {
      "href": "http://www.knitsbysachi.com",
      "target": "_blank"
    }
  }, [_vm._v("www.knitsbysachi.com")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/pg2-2.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c1f0390","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/01_Fm01.vue
// module id = 57
// module chunks = 0